import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { SearchResult } from '../../../shared';

@Component({
    selector: 'app-action-link',
    template: `
    <div class="tw-flex tw-flex-wrap tw-w-full tw-items-center">
      @if (imageUrl) {
        <div class="" style="text-align:center">
          <img
            [src]="imageUrl"
            [attr.width]="imageWidth ? imageWidth : null"
            [attr.height]="imageHeight ? imageHeight : null"
            loading="lazy"
            />
          </div>
        }
        @if (icon) {
          <div class="tw-w-1/5" style="text-align:center">
            <mat-icon class="icon">{{ icon }}</mat-icon>
          </div>
        }
        @if (clickableicon) {
          <div class="tw-w-1/5" style="text-align:center">
            <button
              tabindex="0"
              (keydown.enter)="onLinkClick()"
              [attr.aria-label]="title | translation : translationRequest"
              class="btnlink"
              >
              <a>
                <mat-icon class="icon">{{ clickableicon }}</mat-icon>
              </a>
            </button>
          </div>
        }
        <div class="tw-w-4/5 ">
          <div>
            <button
              tabindex="0"
              (keydown.enter)="onLinkClick()"
              [attr.aria-label]="title | translation : translationRequest"
              (click)="onLinkClick()"
              class="btnlink"
              >
              <b
                ><a>{{ title | translation: translationRequest }}</a></b
                >
              </button>
    
              @if (helpText) {
                <div style="font-size:small;">
                  {{ helpText | translation: translationRequest}}
                </div>
              }
            </div>
          </div>
        </div>
    `,
    styles: [
        `
      .icon {
        font-size: 48px;
        width: 48px;
        height: 48px;
        vertical-align: center;
        color: var(--color-accent);
      }

     
    `,
    ],
    standalone: false
})
export class ActionLinkComponent {
  @Input()
  imageUrl: string;

  @Input()
  icon: string;

  @Input()
  clickableicon: string;

  @Input()
  title: string;

  @Input()
  helpText: string;

  @Input()
  imageWidth: number;

  @Input()
  imageHeight: number;

  @Input()
  claim: SearchResult | null;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  @Output()
  linkClick = new EventEmitter();

  constructor() {}

  onLinkClick() {
    if (this.claim) {
      this.linkClick.emit(this.claim);
    } else {
      this.linkClick.emit();
    }
  }
}
